import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

// A photo in front of the edge of another: the front photo's landscape and
// sun are cut out of it.
export const PhotoStack = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="photo stack icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 1H17A1 1 0 0 1 17 3H3V17A1 1 0 0 1 1 17V3A2 2 0 0 1 3 1ZM8 6H21A2 2 0 0 1 23 8V21A2 2 0 0 1 21 23H8A2 2 0 0 1 6 21V8A2 2 0 0 1 8 6ZM9 20L12.8 14.6L15.2 17.9L16.9 15.7L20 20H9ZM15.75 10.5A1.75 1.75 0 1 0 19.25 10.5A1.75 1.75 0 1 0 15.75 10.5Z"
    />
  </svg>
)
